import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 18h9v-12l-5 2v5l-4 2v-8l9 -4l7 2v13l-7 3l-9 -3","key":"svg-0"}]]

const IconBrandOffice = createReactComponent('outline', 'brand-office', 'BrandOffice', __iconNode);

export default IconBrandOffice;